var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('CTableWrapper',{attrs:{"is-loading":_vm.isLoading,"items":_vm.countries,"small":"","fixed":"","border":"","sorter":"","sorter-value":{ column: 'name', asc: true },"column-filter":"","fields":_vm.fields,"icon":"cil-tags","type":"Country","caption":"Countries"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }